import { TransferCorridor, TransferCorridorSeoSpec } from '../types';

// ============================================================================
// 1. MASTER TRANSFER CORRIDORS DIRECTORY (GLOBAL EXPANSION WAVES 1 -> 5)
// ============================================================================

export const TRANSFER_CORRIDORS_LIST: TransferCorridor[] = [
  // --- WAVE 1: NORTH AMERICA (US & CANADA) ---
  {
    id: 'US_IN_USD_INR',
    sendingCountry: 'US',
    receivingCountry: 'IN',
    sendCurrency: 'USD',
    receiveCurrency: 'INR',
    corridorName: 'United States to India',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 9,
    supportedPaymentMethods: ['BANK_TRANSFER', 'ACH', 'DEBIT_CARD', 'CREDIT_CARD', 'WIRE'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT', 'MOBILE_WALLET'],
    popularAmount: 1000,
    regulatoryNotes: 'RBI limits up to ₹200,000 via UPI/IMPS; larger transfers routed via NEFT/RTGS. Tax Deducted at Source (TCS) rules apply above specific thresholds.',
    averageSpeed: 'Instant to 2 business days',
    searchDemandScore: 98,
    corridorDescription: 'One of the world’s largest remittance corridors. Top providers offer near-instant bank transfers via IMPS and UPI.'
  },
  {
    id: 'US_MX_USD_MXN',
    sendingCountry: 'US',
    receivingCountry: 'MX',
    sendCurrency: 'USD',
    receiveCurrency: 'MXN',
    corridorName: 'United States to Mexico',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 8,
    supportedPaymentMethods: ['DEBIT_CARD', 'ACH', 'BANK_TRANSFER', 'CASH_IN_STORE', 'CREDIT_CARD'],
    supportedPayoutMethods: ['CASH_PICKUP', 'BANK_DEPOSIT', 'CARD_DEPOSIT'],
    popularAmount: 500,
    regulatoryNotes: 'Banco de México SPEI system supports instant bank deposits 24/7. Cash pickup available at OXXO, Elektra, and BanCoppel.',
    averageSpeed: 'Minutes to same-day',
    searchDemandScore: 96,
    corridorDescription: 'Highest volume cash pickup and SPEI direct deposit corridor between US senders and Mexican families.'
  },
  {
    id: 'US_PH_USD_PHP',
    sendingCountry: 'US',
    receivingCountry: 'PH',
    sendCurrency: 'USD',
    receiveCurrency: 'PHP',
    corridorName: 'United States to Philippines',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 8,
    supportedPaymentMethods: ['DEBIT_CARD', 'ACH', 'BANK_TRANSFER', 'CREDIT_CARD'],
    supportedPayoutMethods: ['MOBILE_WALLET', 'BANK_DEPOSIT', 'CASH_PICKUP', 'HOME_DELIVERY'],
    popularAmount: 600,
    regulatoryNotes: 'Bangko Sentral ng Pilipinas (BSP) regulates remittance agents. High mobile wallet adoption (GCash, Maya) with instant credit.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 94,
    corridorDescription: 'Massive diaspora corridor with leading instant payout support for GCash, Maya, Cebuana Lhuillier, and M Lhuillier.'
  },
  {
    id: 'US_GB_USD_GBP',
    sendingCountry: 'US',
    receivingCountry: 'GB',
    sendCurrency: 'USD',
    receiveCurrency: 'GBP',
    corridorName: 'United States to United Kingdom',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['ACH', 'BANK_TRANSFER', 'DEBIT_CARD', 'WIRE'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT'],
    popularAmount: 1500,
    regulatoryNotes: 'UK Faster Payments Service (FPS) enables instant receipt in GBP accounts 24/7/365.',
    averageSpeed: 'Instant to 1 business day',
    searchDemandScore: 89,
    corridorDescription: 'Major transatlantic business and personal transfer corridor with low mid-market spreads and instant FPS rails.'
  },
  {
    id: 'US_EU_USD_EUR',
    sendingCountry: 'US',
    receivingCountry: 'FR',
    sendCurrency: 'USD',
    receiveCurrency: 'EUR',
    corridorName: 'United States to Eurozone',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['ACH', 'BANK_TRANSFER', 'DEBIT_CARD', 'WIRE'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT'],
    popularAmount: 1200,
    regulatoryNotes: 'SEPA Instant credit transfer network delivers funds across 27 EU member states within 10 seconds.',
    averageSpeed: 'Within minutes to 1 day',
    searchDemandScore: 91,
    corridorDescription: 'Direct USD to EUR transfers powered by SEPA and SEPA Instant credit transfer protocols.'
  },
  {
    id: 'CA_IN_CAD_INR',
    sendingCountry: 'CA',
    receivingCountry: 'IN',
    sendCurrency: 'CAD',
    receiveCurrency: 'INR',
    corridorName: 'Canada to India',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['DEBIT_CARD', 'BANK_TRANSFER', 'OPEN_BANKING'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'MOBILE_WALLET', 'CARD_DEPOSIT'],
    popularAmount: 1000,
    regulatoryNotes: 'Interac e-Transfer and EFT commonly utilized for pay-in in Canada. IMPS/UPI for payout.',
    averageSpeed: 'Instant to 1 business day',
    searchDemandScore: 92,
    corridorDescription: 'Key Canadian diaspora route serving students and families with direct Interac funding options.'
  },
  {
    id: 'CA_PH_CAD_PHP',
    sendingCountry: 'CA',
    receivingCountry: 'PH',
    sendCurrency: 'CAD',
    receiveCurrency: 'PHP',
    corridorName: 'Canada to Philippines',
    status: 'ACTIVE',
    wave: 1,
    regionGroup: 'NORTH_AMERICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['MOBILE_WALLET', 'CASH_PICKUP', 'BANK_DEPOSIT'],
    popularAmount: 500,
    regulatoryNotes: 'Instant GCash and Maya mobile wallet disbursements supported by all major Canadian fintech partners.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 88,
    corridorDescription: 'High-frequency remittance route from Canada to the Philippines featuring cash pickup and mobile wallets.'
  },

  // --- WAVE 2: EUROPE & UK ---
  {
    id: 'GB_IN_GBP_INR',
    sendingCountry: 'GB',
    receivingCountry: 'IN',
    sendCurrency: 'GBP',
    receiveCurrency: 'INR',
    corridorName: 'United Kingdom to India',
    status: 'ACTIVE',
    wave: 2,
    regionGroup: 'EUROPE',
    availableProvidersCount: 8,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT', 'MOBILE_WALLET'],
    popularAmount: 800,
    regulatoryNotes: 'UK Open Banking allows zero-fee instant deposit from UK bank accounts directly into remittance providers.',
    averageSpeed: 'Instant to 1 business day',
    searchDemandScore: 93,
    corridorDescription: 'Highly competitive corridor with low margins and instant Open Banking authorization.'
  },
  {
    id: 'GB_PK_GBP_PKR',
    sendingCountry: 'GB',
    receivingCountry: 'PK',
    sendCurrency: 'GBP',
    receiveCurrency: 'PKR',
    corridorName: 'United Kingdom to Pakistan',
    status: 'ACTIVE',
    wave: 2,
    regionGroup: 'EUROPE',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CASH_PICKUP', 'MOBILE_WALLET'],
    popularAmount: 600,
    regulatoryNotes: 'State Bank of Pakistan (SBP) incentives for official remittance channels through the Pakistan Remittance Initiative (PRI).',
    averageSpeed: 'Minutes to same-day',
    searchDemandScore: 90,
    corridorDescription: 'High-volume UK diaspora corridor benefiting from PRI zero-fee government schemes and instant Raast rails.'
  },
  {
    id: 'GB_NG_GBP_NGN',
    sendingCountry: 'GB',
    receivingCountry: 'NG',
    sendCurrency: 'GBP',
    receiveCurrency: 'NGN',
    corridorName: 'United Kingdom to Nigeria',
    status: 'ACTIVE',
    wave: 2,
    regionGroup: 'EUROPE',
    availableProvidersCount: 8,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'MOBILE_MONEY', 'CASH_PICKUP'],
    popularAmount: 500,
    regulatoryNotes: 'Central Bank of Nigeria (CBN) rules permit both NGN and USD cash/account payouts depending on corridor license.',
    averageSpeed: 'Instant to minutes',
    searchDemandScore: 95,
    corridorDescription: 'Fast-growing digital remittance route with instant NIBSS bank transfers and competitive diaspora rates.'
  },
  {
    id: 'FR_MA_EUR_MAD',
    sendingCountry: 'FR',
    receivingCountry: 'MA',
    sendCurrency: 'EUR',
    receiveCurrency: 'MAD',
    corridorName: 'France to Morocco',
    status: 'ACTIVE',
    wave: 2,
    regionGroup: 'EUROPE',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['DEBIT_CARD', 'BANK_TRANSFER', 'OPEN_BANKING'],
    supportedPayoutMethods: ['CASH_PICKUP', 'BANK_DEPOSIT', 'MOBILE_WALLET'],
    popularAmount: 400,
    regulatoryNotes: 'Bank Al-Maghrib oversees Moroccan FX controls. Cash pickup extensively available via Wafacash and Chaabi Bank.',
    averageSpeed: 'Within minutes for cash pickup',
    searchDemandScore: 91,
    corridorDescription: 'Crucial Franco-Moroccan corridor with thousands of cash pickup locations and direct bank deposits.'
  },
  {
    id: 'DE_TR_EUR_TRY',
    sendingCountry: 'DE',
    receivingCountry: 'TR',
    sendCurrency: 'EUR',
    receiveCurrency: 'TRY',
    corridorName: 'Germany to Turkey',
    status: 'ACTIVE',
    wave: 2,
    regionGroup: 'EUROPE',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['BANK_TRANSFER', 'DEBIT_CARD', 'OPEN_BANKING'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CASH_PICKUP'],
    popularAmount: 500,
    regulatoryNotes: 'Turkish CBRT FAST and EFT rails allow rapid TRY account credits; EUR cash pickup available at PTT post offices.',
    averageSpeed: 'Same day to 1 day',
    searchDemandScore: 89,
    corridorDescription: 'Historical and high-volume remittance corridor connecting the Turkish community in Germany.'
  },

  // --- WAVE 3: ASIA-PACIFIC ---
  {
    id: 'AU_IN_AUD_INR',
    sendingCountry: 'AU',
    receivingCountry: 'IN',
    sendCurrency: 'AUD',
    receiveCurrency: 'INR',
    corridorName: 'Australia to India',
    status: 'ACTIVE',
    wave: 3,
    regionGroup: 'ASIA_PACIFIC',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT', 'MOBILE_WALLET'],
    popularAmount: 1000,
    regulatoryNotes: 'Australian PayID / NPP allows instantaneous funding into Australian remittance providers.',
    averageSpeed: 'Instant to 1 business day',
    searchDemandScore: 90,
    corridorDescription: 'Fast-expanding APAC corridor with high mobile banking and PayID integration.'
  },
  {
    id: 'AU_PH_AUD_PHP',
    sendingCountry: 'AU',
    receivingCountry: 'PH',
    sendCurrency: 'AUD',
    receiveCurrency: 'PHP',
    corridorName: 'Australia to Philippines',
    status: 'ACTIVE',
    wave: 3,
    regionGroup: 'ASIA_PACIFIC',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['MOBILE_WALLET', 'CASH_PICKUP', 'BANK_DEPOSIT'],
    popularAmount: 600,
    regulatoryNotes: 'Instant GCash wallet top-ups and cash collections across thousands of Philippine outlets.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 87,
    corridorDescription: 'Major Australian remittance route popular among healthcare and services professionals.'
  },
  {
    id: 'SG_IN_SGD_INR',
    sendingCountry: 'SG',
    receivingCountry: 'IN',
    sendCurrency: 'SGD',
    receiveCurrency: 'INR',
    corridorName: 'Singapore to India',
    status: 'ACTIVE',
    wave: 3,
    regionGroup: 'ASIA_PACIFIC',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['BANK_TRANSFER', 'DEBIT_CARD'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT'],
    popularAmount: 1200,
    regulatoryNotes: 'Direct linkage between Singapore PayNow and India UPI enables real-time low-cost cross-border payments.',
    averageSpeed: 'Instant',
    searchDemandScore: 89,
    corridorDescription: 'Pioneering bilateral instant payment corridor utilizing Singapore PayNow and India UPI linkages.'
  },

  // --- WAVE 4: MIDDLE EAST & LATIN AMERICA ---
  {
    id: 'AE_IN_AED_INR',
    sendingCountry: 'AE',
    receivingCountry: 'IN',
    sendCurrency: 'AED',
    receiveCurrency: 'INR',
    corridorName: 'United Arab Emirates to India',
    status: 'ACTIVE',
    wave: 4,
    regionGroup: 'MIDDLE_EAST',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['BANK_TRANSFER', 'DEBIT_CARD', 'CASH_IN_STORE'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CARD_DEPOSIT'],
    popularAmount: 1500,
    regulatoryNotes: 'CBUAE and RBI bilateral frameworks provide high liquidity and tight exchange rate spreads.',
    averageSpeed: 'Instant to 1 business day',
    searchDemandScore: 96,
    corridorDescription: 'World’s highest-volume Gulf-to-India remittance corridor with exceptional bank-to-bank settlement speeds.'
  },
  {
    id: 'AE_PK_AED_PKR',
    sendingCountry: 'AE',
    receivingCountry: 'PK',
    sendCurrency: 'AED',
    receiveCurrency: 'PKR',
    corridorName: 'United Arab Emirates to Pakistan',
    status: 'ACTIVE',
    wave: 4,
    regionGroup: 'MIDDLE_EAST',
    availableProvidersCount: 5,
    supportedPaymentMethods: ['BANK_TRANSFER', 'DEBIT_CARD', 'CASH_IN_STORE'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CASH_PICKUP'],
    popularAmount: 1000,
    regulatoryNotes: 'PRI incentives apply. Seamless digital and exchange-house based money transmission.',
    averageSpeed: 'Minutes to same-day',
    searchDemandScore: 92,
    corridorDescription: 'Vital economic remittance route supporting families and business ventures across Pakistan.'
  },
  {
    id: 'US_CO_USD_COP',
    sendingCountry: 'US',
    receivingCountry: 'CO',
    sendCurrency: 'USD',
    receiveCurrency: 'COP',
    corridorName: 'United States to Colombia',
    status: 'ACTIVE',
    wave: 4,
    regionGroup: 'LATIN_AMERICA',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['DEBIT_CARD', 'ACH', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CASH_PICKUP', 'MOBILE_WALLET'],
    popularAmount: 400,
    regulatoryNotes: 'Bancolombia, Davivienda, and Efecty network cash collections. Tax regulations apply for large sums.',
    averageSpeed: 'Within minutes for cash pickup',
    searchDemandScore: 88,
    corridorDescription: 'Leading South American corridor featuring direct deposit to Nequi and Daviplata wallets.'
  },

  // --- WAVE 5: AFRICA REGIONAL CORRIDORS ---
  {
    id: 'US_NG_USD_NGN',
    sendingCountry: 'US',
    receivingCountry: 'NG',
    sendCurrency: 'USD',
    receiveCurrency: 'NGN',
    corridorName: 'United States to Nigeria',
    status: 'ACTIVE',
    wave: 5,
    regionGroup: 'AFRICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['DEBIT_CARD', 'ACH', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['BANK_DEPOSIT', 'CASH_PICKUP', 'MOBILE_MONEY'],
    popularAmount: 500,
    regulatoryNotes: 'CBN regulations allow direct NGN deposits into all commercial banks and USD cash pickup at certified branches.',
    averageSpeed: 'Instant to minutes',
    searchDemandScore: 94,
    corridorDescription: 'High-frequency US diaspora corridor with instant bank account deposits across all major Nigerian banks.'
  },
  {
    id: 'US_GH_USD_GHS',
    sendingCountry: 'US',
    receivingCountry: 'GH',
    sendCurrency: 'USD',
    receiveCurrency: 'GHS',
    corridorName: 'United States to Ghana',
    status: 'ACTIVE',
    wave: 5,
    regionGroup: 'AFRICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['DEBIT_CARD', 'ACH', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['MOBILE_MONEY', 'BANK_DEPOSIT', 'CASH_PICKUP'],
    popularAmount: 300,
    regulatoryNotes: 'Bank of Ghana oversees Mobile Money rails (MTN MoMo, Telecel Cash, AT Money) with high digital penetration.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 89,
    corridorDescription: 'Massive mobile money remittance route where over 80% of funds arrive directly into MTN MoMo and Telecel wallets.'
  },
  {
    id: 'FR_CM_EUR_XAF',
    sendingCountry: 'FR',
    receivingCountry: 'CM',
    sendCurrency: 'EUR',
    receiveCurrency: 'XAF',
    corridorName: 'France to Cameroon',
    status: 'ACTIVE',
    wave: 5,
    regionGroup: 'AFRICA',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['DEBIT_CARD', 'BANK_TRANSFER', 'OPEN_BANKING'],
    supportedPayoutMethods: ['MOBILE_MONEY', 'CASH_PICKUP', 'BANK_DEPOSIT'],
    popularAmount: 300,
    regulatoryNotes: 'BEAC regulations govern CEMAC zone remittances. Pegged EUR-XAF parity simplifies exchange rate certainty.',
    averageSpeed: 'Within minutes via Mobile Money',
    searchDemandScore: 88,
    corridorDescription: 'Prominent Central African corridor with instant Mobile Money payouts (Orange Money Cameroon & MTN MoMo).'
  },
  {
    id: 'FR_SN_EUR_XOF',
    sendingCountry: 'FR',
    receivingCountry: 'SN',
    sendCurrency: 'EUR',
    receiveCurrency: 'XOF',
    corridorName: 'France to Senegal',
    status: 'ACTIVE',
    wave: 5,
    regionGroup: 'AFRICA',
    availableProvidersCount: 6,
    supportedPaymentMethods: ['DEBIT_CARD', 'BANK_TRANSFER', 'OPEN_BANKING'],
    supportedPayoutMethods: ['MOBILE_MONEY', 'CASH_PICKUP', 'BANK_DEPOSIT'],
    popularAmount: 250,
    regulatoryNotes: 'BCEAO monetary zone (UEMOA). High adoption of Wave Senegal and Orange Money Senegal.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 89,
    corridorDescription: 'West African diaspora corridor with direct integration to Wave and Orange Money wallets.'
  },
  {
    id: 'GB_KE_GBP_KES',
    sendingCountry: 'GB',
    receivingCountry: 'KE',
    sendCurrency: 'GBP',
    receiveCurrency: 'KES',
    corridorName: 'United Kingdom to Kenya',
    status: 'ACTIVE',
    wave: 5,
    regionGroup: 'AFRICA',
    availableProvidersCount: 7,
    supportedPaymentMethods: ['OPEN_BANKING', 'DEBIT_CARD', 'BANK_TRANSFER'],
    supportedPayoutMethods: ['MOBILE_MONEY', 'BANK_DEPOSIT', 'CASH_PICKUP'],
    popularAmount: 400,
    regulatoryNotes: 'Central Bank of Kenya oversight. M-Pesa is the predominant recipient rail with instantaneous delivery.',
    averageSpeed: 'Within minutes',
    searchDemandScore: 91,
    corridorDescription: 'World-renowned mobile money corridor with real-time disbursement directly into Safaricom M-Pesa wallets.'
  }
];

// ============================================================================
// 2. CORRIDOR SEO METADATA & ELIGIBILITY SPECS
// ============================================================================

export const TRANSFER_CORRIDOR_SEO_SPECS: TransferCorridorSeoSpec[] = [
  {
    corridorId: 'US_IN_USD_INR',
    slug: 'send-money-usa-to-india',
    title: 'Send Money from USA to India: Compare Rates & Fees | YamooPay',
    h1: 'Compare Money Transfers from the United States to India',
    metaDescription: 'Compare verified USD to INR exchange rates, fees, delivery speed, and recipient amounts across top providers (Wise, Remitly, Western Union, Instarem).',
    sendingCountryName: 'United States',
    receivingCountryName: 'India',
    sendCurrency: 'USD',
    receiveCurrency: 'INR',
    seoEligibilityScore: 98,
    status: 'INDEXABLE',
    payoutRailsExplainer: 'Transfers to India are primarily settled via IMPS (Instant Payment Service, up to ₹500,000 in seconds), NEFT for larger sums, or direct UPI handles.',
    regulatoryOverview: 'The Reserve Bank of India (RBI) mandates that remittances for family maintenance undergo standard AML and sender PAN/tax checks where applicable.',
    faqItems: [
      {
        question: 'Which provider gives the highest recipient amount from US to India?',
        answer: 'Wise consistently offers the zero-markup mid-market rate with transparent fees, while Remitly and Instarem offer promotional rates for new customers that may deliver more on small transfers.'
      },
      {
        question: 'How long does a USD to INR transfer take?',
        answer: 'When funded by debit card or instant ACH, bank deposits via IMPS arrive within minutes. Standard ACH or wire transfers take 1 to 2 business days.'
      },
      {
        question: 'What is the maximum amount I can send to India online?',
        answer: 'Most digital providers support between $10,000 and $50,000 per transfer for verified accounts. Specialized brokers like OFX support larger institutional transfers.'
      }
    ],
    lastUpdated: '2026-08-24'
  },
  {
    corridorId: 'US_MX_USD_MXN',
    slug: 'send-money-usa-to-mexico',
    title: 'Send Money from USA to Mexico: Compare Fees & Payouts | YamooPay',
    h1: 'Compare Money Transfers from the United States to Mexico',
    metaDescription: 'Find the best way to send USD to Mexico (MXN). Compare cash pickup at OXXO/Elektra vs SPEI instant bank deposit across verified remittance providers.',
    sendingCountryName: 'United States',
    receivingCountryName: 'Mexico',
    sendCurrency: 'USD',
    receiveCurrency: 'MXN',
    seoEligibilityScore: 96,
    status: 'INDEXABLE',
    payoutRailsExplainer: 'Recipients in Mexico can receive funds via SPEI (instant bank deposit to BBVA, Banorte, Santander) or cash pickup at OXXO, Farmacias Guadalajara, and Elektra.',
    regulatoryOverview: 'Banco de México enforces strict identification requirements for cash collections above $1,000 USD equivalent (INE or valid passport required).',
    faqItems: [
      {
        question: 'Is it better to send to a Mexican bank account or cash pickup?',
        answer: 'Bank deposits via SPEI are generally cheaper with lower FX markups and arrive within minutes. Cash pickup is ideal if the recipient does not have a bank account.'
      },
      {
        question: 'What fees do providers charge for sending money to Mexico?',
        answer: 'Fees range from $0 (promotional/ACH) to $4.99, but pay attention to the exchange rate markup which typically ranges from 0.8% to 2.5%.'
      }
    ],
    lastUpdated: '2026-08-24'
  },
  {
    corridorId: 'US_PH_USD_PHP',
    slug: 'send-money-usa-to-philippines',
    title: 'Send Money from USA to Philippines: Compare GCash & Bank Rates | YamooPay',
    h1: 'Compare Money Transfers from the United States to the Philippines',
    metaDescription: 'Compare the cheapest and fastest ways to send USD to PHP. See live quotes for GCash, Maya, BDO, BPI, and cash pickup at Cebuana Lhuillier.',
    sendingCountryName: 'United States',
    receivingCountryName: 'Philippines',
    sendCurrency: 'USD',
    receiveCurrency: 'PHP',
    seoEligibilityScore: 94,
    status: 'INDEXABLE',
    payoutRailsExplainer: 'Over 65% of remittances to the Philippines are now deposited directly into GCash or Maya mobile wallets within seconds, alongside BDO/BPI bank accounts.',
    regulatoryOverview: 'Remittances are governed by the Bangko Sentral ng Pilipinas (BSP) with standard recipient KYC limits for unverified mobile wallets.',
    faqItems: [
      {
        question: 'Can I send money directly to a GCash wallet from the US?',
        answer: 'Yes, Remitly, WorldRemit, Western Union, and TapTap Send support instant direct deposits into verified Philippine GCash numbers.'
      },
      {
        question: 'How much does it cost to send $500 to the Philippines?',
        answer: 'Total cost typically ranges from $2 to $12 depending on whether you choose economy bank transfer (lower fee) or express card funding (instant delivery).'
      }
    ],
    lastUpdated: '2026-08-24'
  },
  {
    corridorId: 'GB_NG_GBP_NGN',
    slug: 'send-money-uk-to-nigeria',
    title: 'Send Money from UK to Nigeria: Compare NGN Rates & Fees | YamooPay',
    h1: 'Compare Money Transfers from the United Kingdom to Nigeria',
    metaDescription: 'Find verified GBP to NGN exchange rates and zero-fee transfer options. Compare LemFi, Wise, Remitly, and WorldRemit for bank and mobile money payouts.',
    sendingCountryName: 'United Kingdom',
    receivingCountryName: 'Nigeria',
    sendCurrency: 'GBP',
    receiveCurrency: 'NGN',
    seoEligibilityScore: 95,
    status: 'INDEXABLE',
    payoutRailsExplainer: 'Instant bank deposits via NIBSS are supported across GTBank, Access Bank, Zenith Bank, UBA, and Kuda Bank, as well as USD cash pickup.',
    regulatoryOverview: 'Central Bank of Nigeria (CBN) guidelines ensure diaspora remittances are credited swiftly with verified official FX conversion rates.',
    faqItems: [
      {
        question: 'Which provider has the best GBP to NGN rate today?',
        answer: 'LemFi and TapTap Send frequently lead diaspora African routes with competitive rates and zero explicit transfer fees, while Wise offers exact mid-market rate transparency.'
      },
      {
        question: 'How fast do bank transfers arrive in Nigeria from the UK?',
        answer: 'Direct debit card and Open Banking transfers typically settle in the recipient’s Nigerian bank account within 1 to 5 minutes.'
      }
    ],
    lastUpdated: '2026-08-24'
  }
];
